export default "__VITE_ASSET__Br9MAC9p__"